
export class ClaimItem {
    constructor(
        public IdCliente:string,
        public CertificateNumber: string,
        public CallBackNumber:string,
        public FirstName: string,
        public LastName: string,
        public RelationshipTypeCode: string,
        public ChannelCode: string,
        public EmailAddress: string,
        public CultureCode: string,
        public IsAuntheticated: string,
        public ClientIpAddress: string,
        public PurposeCode:string,
        public DealerCode: string,
        public R3Fechaservicio: string,
        public CompanyCode: string,
        public Poliza: string
    ){}

    
}
